'use strict';
import util from './util';
import customModal from './modal';
import validateBirthdayFiled from './validate-birthday-filed';

const selectedChecklist = []; // to store step-2 checklist items

// function to bind DOM events
function newsletterDOMEvents() {
    $('.newsletter_areacode input.phonenumber').each(function (index, ele) {$(ele).removeClass('required'); });

    //on blur phone number
    $('.newsletter-module').on('blur', 'input[name$="_phoneNumber"]', function() {
        const $form = $(this).closest('.newsletter-form-container');
        const selectedCountryCode = $form.find('input[name$="_country"]').val();
        const phone = $(this).val();
        
        if (selectedCountryCode && phone) {            
            const phonenumber = util.getFormattedPhoneNumber(phone, selectedCountryCode);               
            $form.find('input[class~="phone"]').val(phonenumber);
        }
    });

    // Footer Newsletter - Step 1 submit
    $('.newsletter-module').off('submit.newsletterModuleStep1', '.newsletter-form-step1').on('submit.newsletterModuleStep1', '.newsletter-form-step1', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $form = $(this).closest('form');
        const $parentdiv = $(this).closest('.newsletter-module');

        if ($form.data('newsletterSubmitting')) {
            return false;
        }

        if($form.valid()) {
            $form.data('newsletterSubmitting', true);
            // to disable submit button
            $(this).find('button[type="submit"]').addClass('disabled');  
            $(this).find('.newsletter_areacode .areacode').hide();  
            const emailAddress = $(this).find('#dwfrm_newsletter_email').val();
            const source = $(this).closest('.newsletter-form').find('input[name="source"]').val(); 
            validateNewsletter(false, emailAddress, source, $parentdiv, $form);
            $(this).parents().find('.campaign-header').addClass('hidden');
            $(this).parents().find('.campaign-form-wrapper').addClass('center-placed');
            $(this).parents().find('.legal-lines').addClass('hidden');
        }

        return false;
    });
    
    // Footer Newsletter - Step 2 - Skip button
    $('.newsletter-module').on('click', '.footer-skip-btn', function (e) {
        e.preventDefault();
        const parentdiv = $(this).closest('.footer-newsletter-section').length ? '.footer-newsletter-section .newsletter-module' : '.campaign-section .newsletter-module';
        const source = $(this).closest('.step-2 .newsletter-content-zone-right').find('input[name="source"]').val(); 
        
        $.ajax({
            type: 'GET',
            url: util.appendParamsToUrl(Urls.newsletterSuccessMsg, {source : source}),
            success: function(response) {
            	$(parentdiv).html(response);
                $(window).width() < 991 && $('html, body').animate({scrollTop: $(parentdiv).offset().top - 100}, 1000);
            }
        });
    });
    
    // Footer Newsletter - Step 2 - Submit button
    $('.newsletter-module').on('submit', '.newsletter-form-step2', function (e) {
        e.preventDefault();
        const parentdiv = $(this).closest('.footer-newsletter-section').length ? '.footer-newsletter-section .newsletter-module' : '.campaign-section .newsletter-module';
        const source = $(this).closest('.step-2 .newsletter-content-zone-right').find('input[name="source"]').val();  
        
        // to perform add/delete operation on checklist items
        if($(window).width() > 768) {
            $(parentdiv).find('.checklist input[type=checkbox]').each(function() {
                const checkboxVal = $(this).closest('.custom-checkbox').find('label').text();
                if(this.checked) {
                    const isPresent = selectedChecklist.find(function(item){
                        return item.label === checkboxVal;
                    });
                    !isPresent && selectedChecklist.push({label: checkboxVal, value:$(this).val()});
                } else {
                    selectedChecklist.forEach(function(item, index){
                        if (item.label === checkboxVal) {
                            selectedChecklist.splice(index, 1);
                        }
                    });
                }
            });
        }   

        if(selectedChecklist.length) {
            const postData = {};
            postData.intrestsArr = selectedChecklist.map(function(item){ return item.value }).join().toString();
            postData.source = source;
            $.ajax({
                type: 'POST',
                url: Urls.optInMyIntrests,
                data: postData,
                success: function(response) {
                    $(parentdiv).html(response);
                }
            });
            $('.newsletter-content-zone-right #newsletter-interests-error').addClass('hide');
            $(this).find('button[type="submit"]').addClass('disabled');
        } else {
            $('.newsletter-content-zone-right #newsletter-interests-error').removeClass('hide');
            $(this).find('button[type="submit"]').removeClass('disabled');
            return false;
        }   
        $(window).width() < 991 && $('html, body').animate({scrollTop: $(parentdiv).offset().top - 100}, 1000); 
    });

    // to hide error message when at least 1 checkbox selected
    $('.newsletter-module').on('change', '.checklist input[type=checkbox]', function () {
        if(this.checked) {
            $('.newsletter-content-zone-right #newsletter-interests-error').addClass('hide');
        }
    });
    
    // open modal on plus icon click
    $('.newsletter-module').on('click', '.newsletter-addon-widget .icon-plus-circle', function (e) {
        const modalBody = $('.optin-interest-options').html();
        customModal.createCustomModal('newsletter-interest-modal', '.newsletter-module .step-2 .newsletter-content-zone-right');
        $('.newsletter-interest-modal .modal-body').html(modalBody);
        
        const $checkboxes = $('.newsletter-interest-modal .checklist input[type="checkbox"]');
        const $btnValidate = $('.newsletter-interest-modal .footer-validate-btn');
        
        if(selectedChecklist.length && $checkboxes.length) {
            const checkboxMap = {};
            selectedChecklist.forEach(function(item) {
                checkboxMap[item.label] = true;
            });
            
            $checkboxes.each(function() {
                const checkboxVal = $(this).closest('.custom-checkbox').find('label').text();
                this.checked = checkboxMap[checkboxVal] || false;
            });
            
            $btnValidate.removeClass('disabled');
        } else {
            $btnValidate.addClass('disabled');
        }
    });

    // to validate modal checklist add/delete on validate button
    $('.newsletter-module').on('click', '.newsletter-interest-modal .footer-validate-btn', function (e) {
        const $modal = $(this).closest('.newsletter-interest-modal');
        const $checkboxes = $modal.find('.checklist input[type=checkbox]');
        const $label = $modal.find('.addon-widget-header > label');
        let checkedItems = '';

        // Process checkboxes and update selectedChecklist
        if ($checkboxes.length) {
            $checkboxes.each(function() {
                const $checkbox = $(this);
                const checkboxVal = $checkbox.closest('.custom-checkbox').find('label').text();
                const index = selectedChecklist.findIndex(item => item.label === checkboxVal);
                
                if (this.checked && index === -1) {
                    selectedChecklist.push({label: checkboxVal, value: $checkbox.val()});
                } else if (!this.checked && index !== -1) {
                    selectedChecklist.splice(index, 1);
                }
            });
        }

        // Build checklist HTML
        if (selectedChecklist.length) {
            checkedItems = selectedChecklist.map(function(item) {
                return '<div class="checklist-badge"><span class="badge-text">' + item.label + '</span><i class="icon-close"></i></div>';
            }).join('');
        }
        
        $('.newsletter-addon-widget .addon-widget-body').html(checkedItems);
        selectedChecklist.length ? $label.addClass('hide') : $label.removeClass('hide');

        // Close modal
        const $modalOverlay = $(this).closest('.modal-overlay');
        if (!$modalOverlay.hasClass('data-modal')) {
            $modalOverlay.remove();
            $('html').removeClass('modal-open');
        }
    }); 
    
    // to manage validate button disabled state 
    $('.newsletter-module').on('change', '.checklist input[type="checkbox"]', function() {
        const $modal = $(this).closest('.newsletter-interest-modal');
        const $btnValidate = $modal.find('.footer-validate-btn');
        if($modal.find('.checklist input[type=checkbox]:checked').length) {  
            $btnValidate.removeClass('disabled');
        } else {
            $btnValidate.addClass('disabled');
        }
    });

    // remove selected item from the checklist
    $('.newsletter-module').on('click', '.checklist-badge .icon-close', function (e) {
        const $element = $(this).closest('.checklist-badge');
        const $label = $(this).closest('.newsletter-interest-modal').find('.addon-widget-header > label');      
        const badgeText = $element.find('.badge-text').text();
        const index = selectedChecklist.findIndex(item => item.label === badgeText);
        
        if (index !== -1) {
            selectedChecklist.splice(index, 1);
            $element.remove();
            if (selectedChecklist.length === 0) {
                $label.removeClass('hide');
            }
        }
    });}

// function to display see more and see less text in user-consent
function toggleContent() {
    const $selector = $('.toggle-content-wrapper');
    $selector.on('click', '.btn-see-more', function(){
        $(this).closest('.toggle-content-wrapper').removeClass('see-more').addClass('see-less');
    });
    $selector.on('click', '.btn-see-less', function(){
        $(this).closest('.toggle-content-wrapper').removeClass('see-less').addClass('see-more');
    });   
}

function validateNewsletter(isModal, emailAddress, source, parentdiv, $submittedForm) {
    const $parentdiv = $(parentdiv);
    const $validateContainer = isModal ? $('.modal-content') : $parentdiv.find('.newsletter-form');

    $validateContainer.find('input').removeAttr('aria-invalid');
    $validateContainer.find('input').removeAttr('aria-describedby');
    $validateContainer.find('input').removeAttr('class');
        
    let postData = ['dwfrm_newsletter_email=', emailAddress].join('');
    const dataObj = {
        email: emailAddress,
        source: isModal ? 'modal' : source
    };
    const formAction = $parentdiv.find('.newsletter-form-container form').attr('action');

    //add fname and lname if newsletter fro footer has been clicked
    postData += $parentdiv.find('#dwfrm_newsletter_firstName') != undefined ? $parentdiv.find('#dwfrm_newsletter_firstName').val() : '';
    postData += $parentdiv.find('#dwfrm_newsletter_lastName') != undefined ? $parentdiv.find('#dwfrm_newsletter_lastName').val() : '';
    postData += $parentdiv.find('#dwfrm_newsletter_customer_birthmonth') != undefined ? $parentdiv.find('#dwfrm_newsletter_customer_birthmonth').val() : '';
    postData += $parentdiv.find('#dwfrm_newsletter_customer_dob') != undefined ? $parentdiv.find('#dwfrm_newsletter_customer_dob').val() : '';
    postData += $parentdiv.find('#dwfrm_newsletter_customer_birthyear') != undefined ? $parentdiv.find('#dwfrm_newsletter_customer_birthyear').val() : '';
    postData += $parentdiv.find('#dwfrm_newsletter_openQuestion') != undefined ? $parentdiv.find('#dwfrm_newsletter_openQuestion').val() : '';
    dataObj.firstName = $parentdiv.find('#dwfrm_newsletter_firstName') != undefined ? $parentdiv.find('#dwfrm_newsletter_firstName').val() : '';
    dataObj.lastName = $parentdiv.find('#dwfrm_newsletter_lastName') != undefined ? $parentdiv.find('#dwfrm_newsletter_lastName').val() : '';
    dataObj.birthday = $parentdiv.find('#dwfrm_newsletter_customer_dob') != undefined ? $parentdiv.find('#dwfrm_newsletter_customer_dob').val() : '';
    dataObj.birthmonth = $parentdiv.find('#dwfrm_newsletter_customer_birthmonth') != undefined ? $parentdiv.find('#dwfrm_newsletter_customer_birthmonth').val() : '';
    dataObj.birthyear = $parentdiv.find('#dwfrm_newsletter_customer_birthyear') != undefined ? $parentdiv.find('#dwfrm_newsletter_customer_birthyear').val() : '';
    dataObj.shiInterests = $parentdiv.find('#sh-interest-check').length > 0 ? true : false;
    dataObj.shiTermsConditions = $parentdiv.find('#terms-condition-check').length > 0 ? true : false;
    dataObj.openQuestion = $parentdiv.find('#dwfrm_newsletter_openQuestion') != undefined ? $parentdiv.find('#dwfrm_newsletter_openQuestion').val() : '';
    const selectedCountryCode = $('input[name$="_country"]').val();
    const areaCode = util.getCallingCountryCode(selectedCountryCode.toLowerCase());
    if (selectedCountryCode) {
        if (areaCode == $parentdiv.find('#dwfrm_newsletter_phone').val() || $parentdiv.find('#dwfrm_newsletter_phone') == undefined) {
            dataObj.phone = '';
        } else {
            dataObj.phone = $parentdiv.find('#dwfrm_newsletter_phone').val();
        }
    }
    const servicesOpted = [];
    $parentdiv.find('.profile-optin-checkboxes input[type=checkbox]').each(function () {
 	   if(this.checked) {
 		  servicesOpted.push($(this).val());
 	   }
 	});
    dataObj.servicesOpted = servicesOpted.join().toString();
    
    $.ajax({
        type: 'POST',
        url: formAction,
        data: dataObj,
        success: function (response) {
            if (isModal) {
                modal.renderContent(response);
                modal.addCustomClass('newsletter-signup-modal');
                $(document).trigger('clicknewsletter',{'siteloc':'pop-up'});
                if($('input[id="promo-code"]').val() == '') {
                    $('.promo-wrapper').hide();
                } else {
                    $('.promo-wrapper').show();
                }
            } else {
                $parentdiv.html(response);
                const offSet = $parentdiv.closest('.footer-newsletter-section').length ?  100 : $(window).height()/2;   
                $(window).width() < 991 && $('html, body').animate({scrollTop: $parentdiv.offset().top - offSet}, 1000);
                $(document).trigger('clicknewsletter',{'siteloc':'footer'});
            }
        },
        error: function () {
            $submittedForm && $submittedForm.removeData('newsletterSubmitting');
        }
    });
}

// function to popuplate country code in phone field
function populatePhoneFields(phone) {
    const selectedCountryCode = $('input[name$="_country"]').val();
    if (selectedCountryCode) {
        const areaCode = util.getCallingCountryCode(selectedCountryCode.toLowerCase());
        if (areaCode && phone) {	
            const phonenumber = phone.replace(new RegExp('^(\\'+ areaCode +')[\\s-]*(\\d{6,18})$'), '$2');            
            $('input[id$="_areaCode"]').val(areaCode);
            $('input[id$="_phoneNumber"]').val(phonenumber);
        }
    }    
}

// function to validate phone field on SMS option checked
function validatePhoneField() {
    const $selector = $('.newsletter-module');
    $selector.on('change', '#sms-check', function(e) {
        if (this.checked) {
        	$(this).closest('.newsletter-module').find('input[id$="_phoneNumber"]').addClass('required');
        } else {
        	$(this).closest('.newsletter-module').find('input[id$="_phoneNumber"]').removeClass('required');   
        }
    });
    $(document).off('focusout','input[name$="_phoneNumber"]'); 
    $(document).on('focusout','input[name$="_phoneNumber"]', function() {
        if($(this).hasClass('required')) {
            populatePhoneFields($(this).val());
        }
        $(this).closest('form').find('input[name$="_phone"]').val($(this).closest('.input-phone-code').find('input[name$="_areaCode"]').val() + $(this).val());
    });
}

function validateTermsCondition() {
    $('.newsletter-user-consents').on('change', 'input[name="termsConditionCheckbox"]', function(){
        $(this).trigger('blur');
    });
}

const expandNewsletter = function() {
    $('.footer-newsletter-section .newsletter-form-container .email').on('click', function(e) {
        let newsletterForm = $(this).closest('.newsletter-form-container');
        $(newsletterForm).find('.newsletter-expand-section').removeClass('hide'); 
        $(newsletterForm).find('.email-field').removeClass('email-without-focus');  
    });
}

const newsletterModule = {	
    init: function () {
        newsletterDOMEvents();
        toggleContent();
        validateBirthdayFiled.init();
        validateTermsCondition();
        expandNewsletter();
    }
};

export default newsletterModule;
